import "./index.less";
import { AtButtonBase, AtButtonColors } from "../../atoms/AtButtonBase";
import React, { useEffect, useState } from "react";
import cn from "classnames";

export interface IAtButtonGroupProps {
    fitContent?: boolean;
    className?: string;
    spaceBetween?: number;
    buttonLabels: string[];
    buttonColor?: AtButtonColors;
    selectedButtonIndex?: number;
    onClick: (index: number) => void;
    round?: boolean;
}

export const AtButtonGroup: React.FC<IAtButtonGroupProps> = ({
    buttonLabels,
    buttonColor = "primary",
    fitContent,
    className,
    spaceBetween,
    onClick,
    selectedButtonIndex,
    round,
    ...otherProps
}) => {
    const [activeButton, setActiveButton] = useState(selectedButtonIndex ?? 0);

    useEffect(() => {
        if (selectedButtonIndex !== undefined) {
            setActiveButton(selectedButtonIndex);
        }
    }, [selectedButtonIndex]);

    const buttonWidth = fitContent ? "fitContent" : `calc((100% / ${buttonLabels.length}) - ${spaceBetween ?? 4}px)`;
    return (
        <div
            className={cn("AtButtonGroup", fitContent ? "fitContent" : "fullWidth", className, { round: round })}
            {...otherProps}
        >
            {buttonLabels.map((b, index) => {
                return (
                    <AtButtonBase
                        key={index}
                        style={{ width: buttonWidth }}
                        color={activeButton === index ? buttonColor : "ghost"}
                        onClick={() => {
                            onClick(index);

                            if (selectedButtonIndex === undefined) {
                                setActiveButton(index);
                            }
                        }}
                    >
                        {b}
                    </AtButtonBase>
                );
            })}
        </div>
    );
};
